function loadScript(url, cb) {
  cb = cb || (() => {})
  const script = document.createElement('script')
  script.async = true
  script.onerror = () => cb(true)
  let loaded = false
  script.onload = script.onreadystatechange = function() {
    if (!loaded && (!script.readyState || 'loaded' === script.readyState || 'complete' === script.readyState)) {
      loaded = true;
      setTimeout(() => cb(false))
    }
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script)
}

// 埋点捕获及发送
document.addEventListener('click', (e) => {
  const target = findElem(e.target)
  if (!target) {
    return
  }
  const { name, type, param } = target
  window._hmt && window._hmt.push(['_trackEvent', name, type, param]);
}, true);

// 查找元素
function findElem(elem) {
  // 没有父元素
  if (!elem || !elem.getAttribute || elem === document.body || elem === document.documentElement) {
    return false
  }
  const name = elem.getAttribute('data-event-name');
  const type = elem.getAttribute('data-event-type');
  const param = elem.getAttribute('data-event-param');

  if (name || type || param) {
    return { elem, name, type, param }
  }
  return false
}

// 百度统计 引入
loadScript('//hm.baidu.com/hm.js?d06f8617511c35d7eaaa23e187cd568e');
// webtrends 引入
loadScript('//script2.pingan.com/app_js/sdc/src/web.js');
